export default "__VITE_ASSET__RUhHhYvt__"